import React, { useEffect, useState } from 'react'
import {
	PAYMENT_TYPES_SELECT_ITEMS,
	CHARGE_ENTITLEMENT_PARTY_CODES,
	RATE_CLASS_CODE_SELECT_ITEMS,
	getOneDecimalFormattedNumber,
} from '../../../constants'
import { Dropdown } from '../../../common/DropDown'
import {
	validateAlphaRequired,
	hasError,
	removeError,
	validateDecimalRequired,
	validateRequired,
} from '../captureAwbUtils'
import plusIcon from '../../../assets/images/plusBlue.svg'
import deleteIcon from '../../../assets/images/delete_icon_red.png'
import ChargeHeadDropDown from './SubSections/ChargeHeadDropDown'
import { getChargeHeads } from '../../../services/dataCaptureService'
import { useTranslation } from 'react-i18next'
import { CommonDropDown } from '../../../common/Resusable/CommonDropDown'
import CommonInput from '../../../common/Resusable/CommonInput'
import { useDispatch, useSelector } from "react-redux";
import { setMasterDataDetails } from "../../../redux/actions/masterDataActions";
const RatesDetails = ({
	awbDetails,
	setAwbDetails,
	error,
	setError,
	ammendRate,
	setAmmendRate,
	initialLoading,
	setInitialLoading,
	isDisabled,
}) => {
	//for multilingual
	const { t, i18n } = useTranslation(['labels', 'errors'])

	let { awbRateLineDetails, currency, chargeableWeightInSelectedUnit } =
		awbDetails
	const [chargeHeads, setChargeHeads] = useState(null)
	const [filteredChargeHeads, setFilteredChargeHeads] = useState([])
	const [netChargeCalculated, setNetChargeCalculated] = useState(null)
	const masterData = useSelector(state => state?.masterData);
    const dispatch = useDispatch();

	useEffect(() => {
		;(async () => {
			try {
				// let chargeHeads = await getChargeHeads()
				let chargeHeads
				if (masterData?.chargeHeadsMaser && masterData.chargeHeadsMaser.length > 0) {
					chargeHeads = masterData.chargeHeadsMaser
				} else {

					chargeHeads = await getChargeHeads()
					if (chargeHeads && chargeHeads.length > 0) {
						const masterDataPayload = {

							chargeHeadsMaster: chargeHeads
						}
						dispatch(setMasterDataDetails(masterDataPayload))
					}
				}
				if (chargeHeads && chargeHeads.length) {
					setChargeHeads(chargeHeads)
					setFilteredChargeHeads(chargeHeads)
				}
			} catch (err) {
				console.log(err)
			}
		})()
	}, [])

	useEffect(() => {
		setTimeout(() => {
			setInitialLoading(false)
		}, 2000)

		if (
			!initialLoading &&
			awbRateLineDetails &&
			chargeableWeightInSelectedUnit
		) {
			let calculatedNetCharge = chargeableWeightInSelectedUnit * awbRateLineDetails.rate
			setError((prevState) => ({ ...prevState, 'netCharge': '' }))
			awbRateLineDetails.netCharge = parseFloat(calculatedNetCharge).toFixed(2)
			awbRateLineDetails.freightCharge =  parseFloat(calculatedNetCharge).toFixed(2)
			setAwbDetails((prevState) => ({
				...prevState,
				awbRateLineDetails: awbRateLineDetails,
			}))
		}
	}, [chargeableWeightInSelectedUnit, awbRateLineDetails.rate])

	const handleRateAmmend = () => {
		setAmmendRate(!ammendRate)
	}

	const handleAddSurcharge = () => {
		const surcharge = {
			otherChargeCode: '',
			prepaidCollectIndicator: '',
			chargeEntitlementCodeParty: '',
			chargeAmount: null,
			chargeHeadName: '',
			isNew: true,
		}
		let otherCharges = awbRateLineDetails.otherCharges
		if (!awbRateLineDetails.otherCharges) {
			otherCharges = []
		}
		otherCharges.push(surcharge)
		awbRateLineDetails.otherCharges = otherCharges
		setAwbDetails((prevState) => ({
			...prevState,
			awbRateLineDetails: awbRateLineDetails,
		}))
	}

	const handleDeleteAction = (e, index) => {
		let otherCharges = awbRateLineDetails.otherCharges
		const otherChargesTemp = otherCharges.filter((itemDetail, curr) => {
			return index !== curr
		})
		awbRateLineDetails.otherCharges = otherChargesTemp
		setAwbDetails((prevState) => ({
			...prevState,
			awbRateLineDetails: awbRateLineDetails,
		}))
	}

	return (
		<div className='portal-row rate-details'>
			<div className='portal-row'>
					<div className='portal-col'>
						<h4 className='section-heading'>{t('CAPTURE_AWB.RATES')}</h4>
					</div>
				</div>
			<div className='portal-col'>		
			 <div className='rate-details-section-wrapper'>	
				{!ammendRate && (

					<div className='rate-details-table-wrapper'>
						<div className='rate-details-table'>
							{/* Table Header Row */}
							<div className='agent-details-table-row rate-details-table-header'>
								<div>{t('CAPTURE_AWB.FRE_CHARGE')}:</div>
								<div>{t('CAPTURE_AWB.OTHER_CHARGE')}:</div>
								<div>{t('CAPTURE_AWB.IATA_RATE')}:</div>
								<div> <label className='total-charge-label-head' >{t('CAPTURE_AWB.TOT_CHARGE')}</label></div>
							</div>
							{/* Table Data Row */}
							<div className='rate-details-table-row rate-details-table-data'>
								<div>{awbDetails.currency} {awbRateLineDetails.freightCharge}</div>
								<div>{awbDetails.currency} {awbRateLineDetails.surcharges}</div>
								<div>{awbDetails.currency} {awbRateLineDetails.rate}</div>
								<div className='total-charge-label'>{awbDetails.currency} {awbRateLineDetails.totalCharge}</div>
							</div>
						</div>
                     </div>

					// <div className="rate-info-flex-table">
					// 	<div className="rate-info-flex-row rate-info-flex-header">
					// 		<div className="rate-info-flex-cell rate-info-table-heading">{t('CAPTURE_AWB.FRE_CHARGE')}</div>
					// 		<div className="rate-info-flex-cell rate-info-table-heading">{t('CAPTURE_AWB.OTHER_CHARGE')}</div>
					// 		<div className="rate-info-flex-cell rate-info-table-heading">{t('CAPTURE_AWB.IATA_RATE')}</div>
					// 		<div className="rate-info-flex-cell rate-info-table-heading">{t('CAPTURE_AWB.TOT_CHARGE')}</div>
					// 	</div>
					// 	<div className="rate-info-flex-row rate-info-flex-data">
					// 		<div className="rate-info-flex-cell">
					// 			{awbDetails.currency} {awbRateLineDetails.freightCharge}
					// 		</div>
					// 		<div className="rate-info-flex-cell">
					// 			{awbDetails.currency} {awbRateLineDetails.surcharges}
					// 		</div>
					// 		<div className="rate-info-flex-cell">
					// 			{awbDetails.currency} {awbRateLineDetails.rate}
					// 		</div>
					// 		<div className="rate-info-flex-cell">
					// 			{awbDetails.currency} {awbRateLineDetails.totalCharge}
					// 		</div>
					// 	</div>
					// </div>
				)}
				{ammendRate && (
					<div className='rate-info-edit'>
						<div className='portal-row charges'>
							<div className='rate-details-section'>

								<div className='shipping-deparr-row'>

									<div
										className={`form-group ${hasError(`rate`, error) ? "red-border" : ""
											}`}
									>
										<CommonInput
											id='rate'
											type='text'
											label={`${t('CAPTURE_AWB.RATES')}(${currency})`}
											maxLength='20'
											value={awbRateLineDetails.rate}
											disabled={true}
											onChange={(e) => {
												awbRateLineDetails.rate = e.target.value
												setAwbDetails((prevState) => ({
													...prevState,
													awbRateLineDetails: awbRateLineDetails,
												}))
											}}
											onBlur={(e) => {
												validateDecimalRequired(
													e.target.value,
													setError,
													'rate',
													t('CAPTURE_AWB.RATES')
												)
											}}
											aria-invalid={hasError('rate', error)}
											onFocus={(e) => {
												removeError(e, setError)
											}}
											error={error && error['rate']
												? t(error['rate'], { ns: 'errors' })
												: ''}
										/>
									</div>


									<CommonDropDown
										id='rateClass'
										value={awbRateLineDetails.rateClassCode}
										options={RATE_CLASS_CODE_SELECT_ITEMS}
										label={t('CAPTURE_AWB.RATE_CLASS')}
										disabled={true}
										onChange={(e) => {
											awbRateLineDetails.rateClassCode = e.target.value
											setAwbDetails((prevState) => ({
												...prevState,
												awbRateLineDetails: awbRateLineDetails,
											}))
										}}
										onBlur={(e) => {
											validateRequired(e.target.value, setError, `rateClass`, 'CAPTURE_AWB.RATE_CLASS')
										}}
										ariaInvalid={hasError('rateClass', error)}
										onFocus={(e) => {
											removeError(e, setError)
										}}
									/>


								</div>
								<div className='shipping-deparr-row'>

									<div
										className={`form-group ${hasError(`netCharge`, error) ? "red-border" : ""
											}`}
									>
										<CommonInput
											id='netCharge'
											type='text'
											label={`${t('CAPTURE_AWB.NET_CHARGE')}(${currency})`}
											maxLength='20'
											value={awbRateLineDetails.netCharge}
											disabled={true}
											onChange={(e) => {
												awbRateLineDetails.netCharge = e.target.value
												setAwbDetails((prevState) => ({
													...prevState,
													awbRateLineDetails: awbRateLineDetails,
												}))
											}}
											onBlur={(e) => {
												validateDecimalRequired(
													e.target.value,
													setError,
													'netCharge',
													t('CAPTURE_AWB.NET_CHARGE')
												)
											}}
											aria-invalid={hasError('netCharge', error)}
											onFocus={(e) => {
												removeError(e, setError)
											}}
											error={error && error['netCharge']
												? t(error['netCharge'], { ns: 'errors' })
												: ''}
										/>
									</div>


									<CommonDropDown
										id='paymentType'
										value={awbRateLineDetails.paymentType}
										options={PAYMENT_TYPES_SELECT_ITEMS}
										label={t('CAPTURE_AWB.PAY_TYPE')}
										disabled={true}
										onChange={(e) => {
											awbRateLineDetails.paymentType = e.target.value
											setAwbDetails((prevState) => ({
												...prevState,
												awbRateLineDetails: awbRateLineDetails,
											}))
											validateRequired(
												e.target.value,
												setError,
												'paymentType'
											)
										}}
										onBlur={(e) => {
											validateRequired(
												e.target.value,
												setError,
												'paymentType'
											)
										}}
										ariaInvalid={hasError('paymentType', error)}
										onFocus={(e) => {
											removeError(e, setError)
										}}
									/>

								</div>
							</div>
						</div>
						
					 <div className='portal-row other-charges-section-wrapper'>
						<div className='portal-row'>
								<div className='portal-col'>
									<label className='section-sub-heading'>
										{t('CAPTURE_AWB.OTHER_CHARGE')}
									</label>
								</div>
						</div>
						<div className='portal-row  other-charges'>	
							{awbRateLineDetails.otherCharges &&
								awbRateLineDetails.otherCharges.length ? (
								awbRateLineDetails.otherCharges.map((surcharge, index) => (
									<div className='other-charges-section'>
										<div className="shipping-deparr-row">
											<div
												className={`form-group common-autocomplete country-autocomplete-capture ${hasError(`subchargeCode${index}`, error)
													? "red-border"
													: ""
													}`}
											>
												<div className="p-float-label input-wrapper">
													<ChargeHeadDropDown
														setError={setError}
														chargeHeadId={`subchargeCode${index}`}
														chargeHeadNameId={`chargeHead${index}`}
														chargeHeads={chargeHeads}
														value={{
															chargeHeadCode: surcharge.otherChargeCode,
															chargeHeadDescription: surcharge.chargeHeadName,
														}}
														setChargeHeads={setChargeHeads}
														filteredChargeHeads={filteredChargeHeads}
														setFilteredChargeHeads={setFilteredChargeHeads}
														disabled={true}
														setChargeHeadCode={(val) => {
															let otherCharges = awbRateLineDetails.otherCharges
															otherCharges[index].otherChargeCode = val
																? val.chargeHeadCode
																: null
															otherCharges[index].chargeHeadName = val
																? val.chargeHeadDescription
																: ''
															awbRateLineDetails.otherCharges = otherCharges
															setAwbDetails((prevState) => ({
																...prevState,
																awbRateLineDetails: awbRateLineDetails,
															}))
															if (
																otherCharges[index].chargeHeadName &&
																otherCharges[index].chargeHeadName !== ''
															) {
																setError((prevState) => ({
																	...prevState,
																	[`chargeHead${index}`]: '',
																}))
															}
														}}
														isMandatory={true}
													/>
													<label htmlFor="destination-airport">
														{t('CAPTURE_AWB.CODE')}
													</label>
												</div>
												<span className="search-panel__errormsg">
													{error && error[`subchargeCode${index}`]
														? t(error[`subchargeCode${index}`], {
															ns: 'errors',
														})
														: ''}
												</span>
											</div>

											<div
												className={`form-group ${hasError(`chargeHead${index}`, error) ? "red-border" : ""
													}`}
											>
												<CommonInput
													id={`chargeHead${index}`}
													type='text'
													label={t('CAPTURE_AWB.CHARGE_HEAD')}
													maxLength='20'
													value={surcharge.chargeHeadName}
													disabled={true}
													onChange={(e) => {
														let otherCharges = awbRateLineDetails.otherCharges
														otherCharges[index].chargeHeadName = e.target.value
														awbRateLineDetails.otherCharges = otherCharges
														setAwbDetails((prevState) => ({
															...prevState,
															awbRateLineDetails: awbRateLineDetails,
														}))
													}}
													onBlur={(e) => {
														validateRequired(
															e.target.value,
															setError,
															`chargeHead${index}`,
															t('CAPTURE_AWB.CHARGE_HEAD')
														)
													}}
													aria-invalid={hasError(`chargeHead${index}`, error)}
													onFocus={(e) => {
														removeError(e, setError)
													}}
													error={error && error[`chargeHead${index}`]
														? t(error[`chargeHead${index}`], { ns: 'errors' })
														: ''}
												/>
											</div>
										</div>

										<div className="shipping-deparr-row">

											<div
												className={`form-group ${hasError(`subCharge${index}`, error) ? "red-border" : ""
													}`}
											>
												<CommonInput
													id={`subCharge${index}`}
													type='text'
													label={`${t('CAPTURE_AWB.CHARGE')}(${currency})`}
													maxLength='20'
													value={surcharge.chargeAmount}
													disabled={true}
													onChange={(e) => {
														let otherCharges = awbRateLineDetails.otherCharges
														otherCharges[index].chargeAmount = e.target.value
														awbRateLineDetails.otherCharges = otherCharges
														setAwbDetails((prevState) => ({
															...prevState,
															awbRateLineDetails: awbRateLineDetails,
														}))
													}}
													onBlur={(e) => {
														validateDecimalRequired(
															e.target.value,
															setError,
															`subCharge${index}`,
															t('CAPTURE_AWB.CHARGE')
														)
													}}
													aria-invalid={hasError(`subCharge${index}`, error)}
													onFocus={(e) => {
														removeError(e, setError)
													}}
													error={error && error[`subCharge${index}`]
														? t(error[`subCharge${index}`], { ns: 'errors' })
														: ''}
												/>
											</div>

											<CommonDropDown
												id={`subChargePaymentType${index}`}
												value={
													awbRateLineDetails.otherCharges[0]
														.prepaidCollectIndicator
												}
												options={PAYMENT_TYPES_SELECT_ITEMS}
												label={t('CAPTURE_AWB.PAY_TYPE')}
												isUpdate={true}
												disabled={true}
												onChange={(e) => {
													let otherCharges = awbRateLineDetails.otherCharges
													otherCharges[0].prepaidCollectIndicator =
														e.target.value
													awbRateLineDetails.otherCharges = otherCharges
													setAwbDetails((prevState) => ({
														...prevState,
														awbRateLineDetails: awbRateLineDetails,
													}))
													validateRequired(
														e.target.value,
														setError,
														`subChargePaymentType`,
														t('CAPTURE_AWB.PAY_TYPE')
													)
												}}
												onBlur={(e) => {
													validateRequired(
														e.target.value,
														setError,
														`subChargePaymentType`,
														t('CAPTURE_AWB.PAY_TYPE')
													)
												}}
												ariaInvalid={
													index === 0
														? hasError(`subChargePaymentType`, error)
														: false
												}
												onFocus={(e) => {
													setError((prevState) => ({
														...prevState,
														subChargePaymentType: '',
													}))
												}}
											/>

										</div>
										<div className="shipping-deparr-row">

											<CommonDropDown
												id={`dueParty${index}`}
												value={surcharge.chargeEntitlementCodeParty}
												options={CHARGE_ENTITLEMENT_PARTY_CODES}
												label={t('CAPTURE_AWB.DUE_PARTY')}
												disabled={true}
												onChange={(e) => {
													let otherCharges = awbRateLineDetails.otherCharges
													otherCharges[index].chargeEntitlementCodeParty =
														e.target.value
													awbRateLineDetails.otherCharges = otherCharges
													setAwbDetails((prevState) => ({
														...prevState,
														awbRateLineDetails: awbRateLineDetails,
													}))
													validateRequired(
														e.target.value,
														setError,
														`dueParty${index}`,
														t('CAPTURE_AWB.DUE_PARTY')
													)
												}}
												onBlur={(e) => {
													validateRequired(
														e.target.value,
														setError,
														`dueParty${index}`,
														t('CAPTURE_AWB.DUE_PARTY')
													)
												}}
												ariaInvalid={hasError(`dueParty${index}`, error)}
												onFocus={(e) => {
													removeError(e, setError)
												}}
											/>

										</div>
									</div>
								))
							) : (
								<div className='form-row'></div>
							)}
						</div>
					</div>	
					</div>
				)}
				{!ammendRate && (
					<div className='portal-row'>
						<div className='portal-col'>
							<button
								className='add-account-btn'
								style={{ background: 'transparent' }}
								onClick={handleRateAmmend}
								disabled={isDisabled}
							>
								{ammendRate ? t('CAPTURE_AWB.AMMEND') : t('CAPTURE_AWB.DTLS')}
							</button>
						</div>
					</div>
				)}
			</div>	
			</div>
		</div>
	)
}

export default RatesDetails
